import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { PreviewsMutation, PreviewsMutationVariables } from './__generated__/PreviewsMutation';
import { PREVIEWS_MUTATION } from './previews.mutation';

export const usePreviewsMutation = () => {
  const [createCreativeTemplate] = useMutation<PreviewsMutation, PreviewsMutationVariables>(PREVIEWS_MUTATION, {
    client: kmsClient
  });
  return (variables: PreviewsMutationVariables) =>
    createCreativeTemplate({ variables }).then((response) =>
      response.data?.generateCreativeTemplatesPreviews?.errors?.length
        ? Promise.reject(response.data.generateCreativeTemplatesPreviews.errors)
        : response.data?.generateCreativeTemplatesPreviews?.previews || []
    );
};
